<template>
  <div class="add-material-modal">
    <q-form @submit="onSubmit" class="modal-form">
      <div class="modal-content">
        <div class="form-field">
          <CustomSelect :options="providerTypes" label="Поставщик" option-label-key="provider_name"
            option-value-key="provider_id" @change="value => onChange('provider_id', value)" :value="formData.provider_id"
            placeholder="Не выбрано" required />
        </div>

        <div class="form-field">
          <CustomInput label="Наименование материала поставщика" placeholder="Введите..."
            :value="formData.provider_material_name" @change_input="(value) => onChange('provider_material_name', value)" required
            :showClearIcon="false" />
        </div>

        <div class="form-field">
          <CustomCheckbox :value="formData.is_main" label="Основной поставщик"
            @change="value => onChange('is_main', value)" size="xs" />
        </div>

        <div class="form-field">
          <CustomCheckbox :value="formData.is_avail" label="Есть в наличии"
            @change="value => onChange('is_avail', value)" size="xs" />
        </div>
      </div>
      <CustomModalFooter :btn-loading="loading" />
    </q-form>
  </div>
</template>

<script>
import CustomButton from '@/components/common/CustomButton'
import CustomIcon from '@/components/common/CustomIcon'
import SvgIcon from '@/components/common/SvgIcon'
import CustomCheckbox from '@/components/form/CustomCheckbox'
import CustomDate from '@/components/form/CustomDate'
import CustomInput from '@/components/form/CustomInput'
import CustomSelect from '@/components/form/CustomSelect'
import CustomModalFooter from '@/components/modal/modals/modal-footer'
import { getProviders } from '@/views/Materials/services'

export default {
  name: 'add-provider-entry',
  components: {
    CustomInput,
    CustomSelect,
    CustomButton,
    CustomDate,
    SvgIcon,
    CustomIcon,
    CustomModalFooter,
    CustomCheckbox,
  },
  props: ['data', 'props'],
  data() {
    return {
      loading: false,
      formData: {
        material_provider_id: this.data?.body?.material_provider_id || '',
        material_id: this.data?.body?.material_id || '',
        provider_material_name: this.data?.body?.provider_material_name || "",
        provider_id: this.data?.body?.provider_id || '',
        is_main: this.data?.body?.is_main
          ? Boolean(this.data.body.is_main)
          : false,
        is_avail: this.data?.body?.is_avail
          ? Boolean(this.data.body.is_avail)
          : false,
      },
      providerTypes: [],
    }
  },
  methods: {
    async getProviderTypes() {
      const res = await getProviders()
      this.providerTypes = res || []
    },
    onChange(key, value) {
      this.formData[key] = value
    },
    onCancel() {
      if (this.data?.onCancel) {
        this.data.onCancel()
      }
    },
    async onSubmit() {
      if (!this.formData.provider_id) {
        return
      }

      this.loading = true
      const payload = {
        material_id: this.formData.material_id,
        provider_material_name: this.formData.provider_material_name,
        provider_id: this.formData.provider_id,
        is_main: this.formData.is_main ? 1 : 0,
        is_avail: this.formData.is_avail ? 1 : 0,
      }

      if (this.data?.body?.material_provider_id) {
        payload.material_provider_id = this.formData.material_provider_id
      }

      if (this.data?.onSubmit) {
        await this.data.onSubmit(payload)
      }
      this.loading = false
    },
  },
  mounted() {
    this.getProviderTypes()
  },
}
</script>

<style scoped lang="scss">
.add-material-modal {
  max-width: 627px;
  width: 100%;
}

.modal-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.modal-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-field {
  width: 100%;

  :deep(.q-checkbox__label) {
    color: #373d48;
    font-size: 14px;
  }
}

.field-label {
  display: block;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.29;
  color: #000000;
  margin-bottom: 8px;
}

.units-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px;
  background: #f2f5f8;
  border-radius: 8px;
}

.units-row {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
}

.unit-group {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.arrow-icon {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #9ca3af;
  border-radius: 50%;
  width: 24px;
  height: 24px;

  .q-icon {
    width: 24px;
    height: 24px;
  }
}

@media (max-width: 768px) {
  .add-material-modal {
    max-width: 100%;
  }

  .modal-footer {
    width: 100%;
  }

  .units-row {
    flex-direction: column;
    align-items: stretch;
  }

  .arrow-icon {
    transform: rotate(90deg);
    padding: 8px 0;
  }
}
</style>
